import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'secondsToMinutes'
})
export class SecondsToMinutesPipe implements PipeTransform {

 static addAdditionalZeroToTime(time): string {
    time = time.toString();
    return time.length < 2 ? '0' + time : time;
  }

  transform(s: any, timeDescription:boolean = false, withHours: boolean = false, withOutSeconds: boolean = false): any {
    s = Math.abs(s);
    let minutes = (s - (s %= 60)) / 60;
    let hours = (minutes - (minutes %= 60)) / 60;
    if(timeDescription){
      return minutes > 0 ? ( minutes + (minutes === 1? ' minute ': ' minutes ') + s + ' seconds') : s + ' seconds';
    }else {
      if(withHours){
        return !withOutSeconds ?
          ((hours < 10 ? '0': '') + hours.toString(10) + (9 < minutes ? ':' : ':0') +
          minutes.toString(10)  +  (9 < s ? ':' : ':0') + s) :
          ((hours < 10 ? '0': '') + hours.toString(10) + (9 < minutes ? ':' : ':0') +
            minutes.toString(10));
      }
        return (SecondsToMinutesPipe.addAdditionalZeroToTime(minutes)  + (9 < s ? ':' : ':0') + s);
    }
  }

}
